export const parseAmount = (value) => {
  if (value === null || value === undefined || value === "") return null;
  const parsed = Number.parseFloat(String(value).replace(/\s+/g, "").replace(",", "."));
  return Number.isFinite(parsed) ? parsed : null;
};

export const checkTotalsMismatch = (document) => {
  if (!document) return false;
  const totalAmount = parseAmount(document.total_amount);
  const netAmount = parseAmount(document.net_amount);
  const taxAmount = parseAmount(document.total_tax_amount);

  if (totalAmount === null || netAmount === null || taxAmount === null) return false;
  return Math.abs(totalAmount - (netAmount + taxAmount)) > 0.01;
};

export const checkLineItemsMismatch = (document) => {
  if (!document) return false;
  const lineItems = document?.line_items;
  if (!Array.isArray(lineItems) || lineItems.length === 0) return false;

  let hasIncompleteLine = false;
  const lineItemsTotal = lineItems.reduce((sum, item) => {
    if (["settlement", "informational"].includes(item.line_type)) return sum;
    const explicitTotal = parseAmount(item.total_amount);
    if (explicitTotal !== null) return sum + explicitTotal;

    const quantity = parseAmount(item.quantity);
    const unitPrice = parseAmount(item.unit_price);
    if (quantity !== null && unitPrice !== null) return sum + quantity * unitPrice;
    hasIncompleteLine = true;
    return sum;
  }, 0);

  if (hasIncompleteLine) return true;

  const adjustments = document.financial_adjustments;
  const adjustmentsTotal = Array.isArray(adjustments)
    ? adjustments.reduce(
        (sum, adjustment) =>
          adjustment?.disabled ? sum : sum + (parseAmount(adjustment.amount) || 0),
        0
      )
    : 0;
  const financialTotal = lineItemsTotal + adjustmentsTotal;

  const netAmount = parseAmount(document.net_amount);
  const totalAmount = parseAmount(document.total_amount);

  // Line items in an invoice represent items without VAT (net / be PVM).
  // If net_amount is present, line items total MUST match net_amount!
  if (netAmount !== null) {
    return Math.abs(netAmount - financialTotal) > 0.02;
  }

  // If net_amount is missing, compare with total_amount
  if (totalAmount !== null) {
    return Math.abs(totalAmount - financialTotal) > 0.02;
  }

  return false;
};

/**
 * A document is valid when:
 * 1. Header totals add up (net + tax === total)
 * 2. Line items are complete and add up to net_amount (or total_amount if net is missing)
 */
const validateTotals = (document) => {
  if (!document) return false;

  // 1. If header totals mismatch, document is invalid!
  if (checkTotalsMismatch(document)) {
    return false;
  }

  // 2. If line items mismatch, document is invalid!
  if (checkLineItemsMismatch(document)) {
    return false;
  }

  const lineItems = document?.line_items;
  if (!Array.isArray(lineItems) || lineItems.length === 0) return false;

  const netAmount = parseAmount(document.net_amount);
  const totalAmount = parseAmount(document.total_amount);
  if (netAmount === null && totalAmount === null) return false;

  return true;
};

export default validateTotals;
